<div class="add-coupon-dialog">
  <h2 class="dialog-title">Añadir cupón</h2>
  <p class="dialog-subtitle">
    Introduce tu cupón de descuento para aplicarlo a tu suscripción.
  </p>

  <div class="dialog-field">
    <label>Código de cupón</label>
    <input 
      type="text" 
      class="form-control" 
      [(ngModel)]="couponCode" 
      placeholder="Ej: BIENVENIDA10"
      [disabled]="isApplying"
      (keyup.enter)="apply()" />
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger" style="margin-top: 10px; padding: 10px; border-radius: 4px; background-color: #f8d7da; color: #721c24; border: 1px solid #f5c6cb;">
    {{ errorMessage }}
  </div>

  <div *ngIf="successMessage" class="alert alert-success" style="margin-top: 10px; padding: 10px; border-radius: 4px; background-color: #d4edda; color: #155724; border: 1px solid #c3e6cb;">
    {{ successMessage }}
  </div>

  <div *ngIf="isApplying" style="margin-top: 10px; text-align: center; color: #666;">
    Aplicando cupón...
  </div>

  <p class="dialog-note" *ngIf="!errorMessage && !successMessage && !isApplying">
    El cupón se aplicará inmediatamente a tu suscripción activa.
  </p>

  <div class="dialog-actions">
    <button 
      type="button" 
      class="btn-back" 
      (click)="close()"
      [disabled]="isApplying">
      Cancelar
    </button>
    <button 
      type="button" 
      class="btn-confirm" 
      [disabled]="!couponCode || couponCode.trim() === '' || isApplying" 
      (click)="apply()">
      {{ isApplying ? 'Aplicando...' : 'Aplicar cupón' }}
    </button>
  </div>
</div>
